import {ConversionUtils} from "./ConversionUtils";

export class BrowserUtils {
    public static getURLPathWithoutQuery() {
        return location.protocol + "//" + location.host + location.pathname;
    }

    public static getQueryParams(): any {
        return ConversionUtils.htmlDecode(window.location.search);
    }

    public static getCurrentBaseURL() {
        if (window.location.href.indexOf('index.php?') > -1) {
            return window.location.href.split("index.php?")[0];
        }
        return window.location.href.split("?")[0];
    }
}
